module.exports = "../study/imgs/maps/Tokyo/S8/Ecosystem/PinusPumila/Tokyo_PinusPumila_GFDL_RCP45_Mid.png";